import React from 'react';

import FormTitle from 'components/PageLayout/FormTitle';
import { EnvironmentVariable } from 'enums/curo/EnvironmentVariable';
import { envs } from 'envs';

import styles from './EndPages.module.scss';

const PAGE_TITLE = 'Your funding is in process';
const PAGE_DESCRIPTION = (
  <p className={styles.descriptionWrapper}>
    You already have an approved application, and your funding is in process. We have initiated your
    funding, but the timing of access is dependent on your bank. If you have any questions, please
    call <strong>{envs[EnvironmentVariable.CuroContactPhoneNumber]}</strong> (Mon - Fri 9am – 7pm
    Eastern Time, excl. holidays).
  </p>
);

const ContactSupportPage = () => {
  return <FormTitle title={PAGE_TITLE} subTitle={PAGE_DESCRIPTION} />;
};

export default ContactSupportPage;
